import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGatewayGetTransactionsPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-paginated.form-default-values';
import { GatewayGetTransactionsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterSearchTransactionListContextProvider,
  useTransactionListContext,
} from '../transaction.context';
import { TransactionListFilterSearchFormController } from './transaction-list-filter-search-form/transaction-list-filter-search-form.controller';

interface TransactionListFilterSearchControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const TransactionListFilterSearchController = ({
  onCancel,
  onSuccess,
}: TransactionListFilterSearchControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useTransactionListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<
    GatewayGetTransactionsPaginatedModel
  > = (errors) => {
    Logger.error(errors);
    toast.error(
      t('$.transaction-list-filter-search.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GatewayGetTransactionsPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        textToSearch: fieldValues.textToSearch,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGatewayGetTransactionsPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterSearchTransactionListContextProvider data={data}>
      <TransactionListFilterSearchFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterSearchTransactionListContextProvider>
  );
};
